const UNTOUCHED = 'ng-untouched';
const toClassList = (classNames) => String(classNames).trim().split(' ');
/**
 * @hidden
 */
export const hasClass = (element, className) => Boolean(toClassList(element.className).find((name) => name === className));
/**
 * @hidden
 */
export function invokeElementMethod(element, name, ...args) {
    if (element && element.nativeElement) {
        return element.nativeElement[name].apply(element.nativeElement, args);
    }
}
/**
 * @hidden
 */
export function isDocumentAvailable() {
    return typeof document !== 'undefined';
}
/**
 * @hidden
 */
export const isUntouched = (element) => element && element.nativeElement && hasClass(element.nativeElement, UNTOUCHED);
const w = () => Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
/**
 * @hidden
 */
export const guid = () => `${w()}${w()}-${w()}-${w()}-${w()}-${w()}${w()}${w()}`;
